export default __webpack_public_path__ + "static/media/RANKING_DNIA.5da0e8fd.png";